import { useMutation } from '@tanstack/react-query';
import { makeSupplierServiceApi } from '../SupplierServiceApi';

type Filter = {
  startDate: string;
  endDate: string;
};

export const useVccTransactionsCSV = () => {
  const client = makeSupplierServiceApi();
  
  return useMutation({
    mutationKey: ['vcc-transactions-csv'],
    mutationFn: (filter: Filter) => client.vccTransactionsCSV(filter)
  });
}
